import request from '@/utils/request'
import API from '@/api/index.js'

// 登录方法
export function dwLogin (data) {
  return request({
    url: '/session/user/v6/login',
    method: 'post',
    data
  })
}

// 退出方法
export function logout () {
  return request({
    url: API.logOut,
    method: 'post'
  })
}

// 用户单点登录
export function ssologin (data) {
  return request({
    url: 'sso/gxy/v1/login',
    method: 'post',
    data
  })
}

// 获取用户数据
export function getDefault (data) {
  return request({
    url: 'usercenter/user/v2/getDefault',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/dw-login.js